import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';

import { formatCurrencyToGBP } from '@utils';

export class TariffPlanPrice extends Model({
  /**
   * Regular price
   */
  regular: '0.00',
  /**
   * Price with discount
   */
  current: '0.00',
  currency: 'GBP',
  localizedRegular: types.maybe(types.string),
  localizedCurrent: types.maybe(types.string),
}) {
  get hasDiscount() {
    return (
      this.regular !== this.current ||
      this.localizedRegular !== this.localizedCurrent
    );
  }

  get formattedRegular() {
    return this.localizedRegular ?? formatCurrencyToGBP(this.regular);
  }

  get formattedCurrent() {
    return this.localizedCurrent ?? formatCurrencyToGBP(this.current);
  }

  get isFree() {
    return Number(this.current) === 0;
  }
}

export const TariffPlanPriceModel = model(TariffPlanPrice);
